import React from "react";
import PageHeader from "../../components/PageHeader";
import FaqCreate from "../../components/FAQ/FaqCreate";

class CmsCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="CMS Create"
                            Breadcrumb={[
                                { name: "FAQ", navigate: "/faq" },
                                { name: "Faq Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <FaqCreate />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsCreate;
